import usdc from 'assets/images/coins/usdc.png';
import { Button } from 'components/Button/Button';
import { ErrorToast } from 'components/Toasts/Toasts';
import { networks } from 'helpers/helpers';
import {
  addToCartLS,
  getCartFromLS,
  removeCartFromLS,
} from 'helpers/localstorage-helper';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { SHIPPING_BILLING } from 'routes/routes';
import { BackIcon, RightIcon, TrashIcon, colors } from 'styles';
import { H3, H4, H5, P1, P2 } from '../../styles/FontStyles';
import { Div, Img, Separator } from '../../styles/Styles';

export const Cart = () => {
  const [card, setCard] = useState<any>(getCartFromLS());
  const [selectedNetwork, setSelectedNetwork] = useState<any>(null);

  const navigate = useNavigate();

  const networkType = (name: string) => {
    if (name === 'BINANCE') {
      return 'bep_20';
    } else if (name === 'TRON') {
      return 'trc_20';
    } else {
      return 'ultron';
    }
  };

  const checkNetwork = () => {
    if (selectedNetwork === null) {
      ErrorToast('Please select network');
    } else {
      const cart = {
        ...card,
        selectedNetwork: networkType(selectedNetwork.name),
      };

      addToCartLS(cart);
      navigate(SHIPPING_BILLING);
    }
  };

  return (
    <>
      <Div $flex $gap='40px' $width='100%' $columnSM>
        <Div $width='65%' $widthSM='100%'>
          <Div
            $flex
            $alignCenter
            $gap='10px'
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          >
            <BackIcon />
            <H3 color={colors.white}>Continue Shopping</H3>
          </Div>

          <Separator $m='20px 0' />
          <H3 color={colors.white} mb='5'>
            Shopping cart
          </H3>

          {card !== 0 && (
            <Div
              $box
              $borderRadius='18px'
              $flex
              $alignCenter
              $between
              $p='16px 32px 16px 8px'
            >
              <Div $flex $alignCenter $gap='16px'>
                <Img src={card.imageUrl} $height='75px' $heightSM='60px' />
                <Div>
                  <H4 color={colors.white} mb='5'>
                    {card.name}
                  </H4>
                  <P2 color={colors.white}>{card.price} USDC</P2>
                </Div>
              </Div>
              <Div $flex $alignCenter $gap='50px' $gapSM='20px'>
                <P2 color={colors.white}>{card.price} USDC</P2>
                <div
                  onClick={() => {
                    setCard(0);
                    removeCartFromLS();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <TrashIcon />
                </div>
              </Div>
            </Div>
          )}
        </Div>
        <Div $width='35%' $widthSM='100%'>
          <Div $box $flex $column>
            <H3 mb='20' color={colors.white}>
              Deposit Crypto
            </H3>
            <P1 mb='10' color={colors.white}>
              Payment Coin
            </P1>

            <Div $flex $gap='12px' $width='100%'>
              <Div $width='33%' $widthSM='100%'>
                <Div>
                  <Div
                    $box
                    $p='10px 0'
                    $flex
                    $center
                    $gap='4px'
                    $borderRadius='8px'
                  >
                    <img src={usdc} style={{ width: 32 }} />
                    <P2 center color={colors.white}>
                      USDC
                    </P2>
                  </Div>
                </Div>
              </Div>
            </Div>

            <P1 mb='10' mt='24' color={colors.white}>
              Select Network
            </P1>

            <Div $flex $columnSM $gap='12px' $gapSM='16px' $width='100%'>
              {networks.map((network, i) => (
                <NetworkComponent
                  key={i}
                  network={network}
                  selectedNetwork={selectedNetwork}
                  setSelectedNetwork={setSelectedNetwork}
                />
              ))}
            </Div>

            <Separator $m='20px 0' />

            <InfoValue
              info='Total (Tax incl.)'
              value={`${card !== 0 ? `$${card.price}` : 0}`}
            />

            <Div $mt='24px'>
              <Button
                $color={colors.blue}
                disabled={card === 0}
                onClick={() => checkNetwork()}
              >
                <Div $flex $between $alignCenter $width='100%' $p='0 12px'>
                  <H5>${card !== 0 ? card.price : 0} USDC</H5>
                  <Div $flex $alignCenter>
                    <H5>Checkout</H5>
                    <RightIcon />
                  </Div>
                </Div>
              </Button>
            </Div>
          </Div>
        </Div>
      </Div>
    </>
  );
};

const InfoValue = ({ info, value }: any) => (
  <Div $flex $between $alignCenter $m='5px 0'>
    <P2 color={colors.white}>{info}</P2>
    <P2 color={colors.white}>{value}</P2>
  </Div>
);

const NetworkComponent = ({
  network,
  selectedNetwork,
  setSelectedNetwork,
}: any) => {
  return (
    <Div $width='100%' $widthSM='100%'>
      <Div>
        <Div
          $box
          $p='10px 0'
          $flex
          $center
          $gap='4px'
          $borderRadius='8px'
          $pointer
          onClick={() => setSelectedNetwork(network)}
          $borderColor={selectedNetwork === network ? colors.primary : ''}
        >
          <img src={network.icon} style={{ width: 32 }} />
          <P2 center color={colors.white}>
            {network.name}
          </P2>
        </Div>
        <P1 mt='4' center color={colors.white}>
          ({network.network})
        </P1>
      </Div>
    </Div>
  );
};
